export default {
  path: '/reports/equitable-services-referrals-report',
  component: () =>
    import('@/views/general-reports/referral-equitable-services/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'equitable-services-referrals-report',
      component: () =>
        import('@/views/general-reports/referral-equitable-services/Main.vue'),
    },
  ],
};
